import React from 'react'
import HealthcareBanner from '../Healthcare/HealthcareBanner';
import HealthcareExcellence from '../Healthcare/HealthcareExcellence';
import HealthcareFacility from '../Healthcare/HealthcareFacility';
import HealthcareCounter from '../Healthcare/HealthcareCounter';
import HealthcareSmart from '../Healthcare/HealthcareSmart';
import HealthcarePremise from '../Healthcare/HealthcarePremise';
import HealthcareBrand from '../Healthcare/HealthcareBrand';
import HealthcareBusinesse from '../Healthcare/HealthcareBusinesse';
import HealthcareFaq from '../Healthcare/HealthcareFaq';
import HomeProducts from '../../home/HomeProducts';

export default function Pharma({ initialData }) {

    const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/pharmaceutical-grade-commercial-laundry",
                name: "Pharma"
            }
        ]

    }



    const Banner = {
        buttonText: "Global Markets",
        buttonLink: "/markets",
        title: "Pharmaceutical Grade Laundry Solutions",
        description: "Supershine delivers GMP-compliant laundry systems engineered for pharmaceutical facilities, ensuring contamination-free processing, complete batch traceability, and validated performance for cleanroom garments, lab coats, and critical protective wear.",
        image: "/assets/images/pharma-banner1.webp"
    };

    const excellenceData = {
        subtitle: "Sterile Processing Technology",
        title: "Engineered for Pharmaceutical Compliance",
        description1: "Pharmaceutical manufacturing demands absolute contamination control, validated processes, and regulatory traceability. Supershine systems are purpose-built for pharma environments, delivering sterile results, documented validation, and audit-ready compliance that meets FDA, GMP, and international standards.",
        description2: "From ISO-classified cleanroom garments to laboratory textiles and protective wear, our barrier washer systems ensure pharmaceutical-grade sterility through HEPA filtration, monitored cycles, and validated protocols that protect product integrity and regulatory standing.",
        buttonText: "Talk to Our Experts",
        buttonLink: "/contact"
    };


    const facilityData = {
        title: "Meeting Pharmaceutical <br> Industry Standards",
        items: [
            {
                icon: "/assets/images/pharma-icon1.webp",
                heading: "Validated Processing",
                description: "FDA and GMP-compliant wash protocols with complete documentation, IQ/OQ/PQ qualification, and audit-ready traceability. Full regulatory compliance guaranteed."
            },
            {
                icon: "/assets/images/pharma-icon2.webp",
                heading: "Isolation & Protection",
                description: "Segregated clean/dirty side processing prevents cross-contamination through physical isolation and HEPA-filtered air systems."
            },
            {
                icon: "/assets/images/pharma-icon3.webp",
                heading: "Monitored Performance",
                description: "Real-time temperature, chemical, and cycle monitoring with automated data logging for regulatory compliance verification."
            },

            {
                icon: "/assets/images/pharma-icon4.webp",
                heading: "Cleanroom Classification",
                description: "Low-particulate design supports ISO cleanroom standards with minimal lint generation and contamination-safe construction."
            },

            {
                icon: "/assets/images/pharma-icon5.webp",
                heading: "Batch Traceability",
                description: "Complete lot tracking from loading to completion ensures accountability for every pharmaceutical textile processed. Real-time monitoring keeps you in control."
            },


            {
                icon: "/assets/images/pharma-icon6.webp",
                heading: "Sterility Assurance",
                description: "Validated thermal disinfection cycles eliminate microbial contamination while protecting delicate cleanroom fabric integrity."
            }
        ]
    };


    const HeathCareCounter = {
        title: "Proven Pharmaceutical Performance",
        stats: [
            {
                end: 200,
                suffix: "+",
                text: "Pharma Facilities <br> Trust Our Systems",
            },
            {
                end: 99.9,
                suffix: "%",
                text: "Validated Contamination  <br>  Control",
            },
            {
                end: 150,
                suffix: "+",
                text: "Daily Cleanroom <br>   Garment Loads",
            },
            {
                prefix: "",
                end: 40,
                suffix: "%",
                text: "Reduced Validation Time <br>  vs Industry Standard",
            },
        ],
    };

    const Fashionsmart = {
        extraClass: "",
        heading: `Validation Support You Can Trust`,
        description: "We handle everything; equipment, documentation, training, and compliance, so your facility stays GMP-ready. From installation to ongoing support, your success is our priority. Partner with us for complete peace of mind.",
        buttonText: "Learn More",
        buttonLink: "/about",
        altText: "Smart"
    };


    const PremiseData = {
        image: "/assets/images/pharam-left-image.webp",
        title: "The Pharmaceutical Advantage",
        subtitle: "Why Leading Pharma Facilities Choose Validated Systems:",
        reasons: [
            "Achieve regulatory confidence with pre-validated equipment, complete qualification documentation, and audit-ready compliance records.",
            "Eliminate cross-contamination through physical barrier separation, HEPA filtration, isolated processing chambers, and validated cleaning protocols.",
            "Maintain cleanroom integrity with low-lint construction, particulate-controlled design, and ISO classification-compatible processing environments.",
            "Ensure batch accountability through automated tracking, digital record-keeping, electronic signatures, and complete chain-of-custody documentation.",
            "Accelerate facility startup with pre-qualified systems, standardized validation protocols, regulatory expertise, and comprehensive commissioning support."
        ],
        buttonText: "Design Your Hotel Solution",
        buttonLink: "/contact"
    };


    const healthcareBrandData = {
        title: "",
        logos: [
            { image: "/assets/images/home-brand-logos3.webp", title: "Brand 1" },
            { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
            { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
            { image: "/assets/images/hospital-new-img1.webp", title: "Brand 4" },
            { image: "/assets/images/hospital-new-img2.webp", title: "Brand 5" },
            { image: "/assets/images/hospital-new-img3.webp", title: "Brand 6" },
            { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
            { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
        ]
    };



    const businessData = {
        title: "Validated By Pharma, <br/> Trusted  For Compliance.",
        description:
            "From validated wash cycles to contamination control, pharmaceutical manufacturers count on Supershine for excellence in cleanroom garment processing.",
        testimonials: [
            {
                rating: 5,
                text:
                    "“Cleanroom garment processing has extremely tight contamination control requirements, and our previous setup struggled to meet validation standards consistently. Supershine's equipment has given us repeatable, documented wash cycles that satisfy our quality audits without exception.”",
                client: "Karthik Subramaniam, QA Manager, Pharmaceutical Manufacturing Unit",
            },
            {
                rating: 5,
                text:
                    "“GMP compliance means every process needs traceability, including garment hygiene. Supershine helped us set up a system where wash parameters are logged and consistent across every batch of cleanroom apparel. During our last regulatory inspection, this was specifically called out as a strength. ”",
                client: "Meera Joshi, Compliance Officer, Pharma Plant",
            },
            {
                rating: 5,
                text:
                    "“Our production runs around the clock, so equipment reliability isn't optional. Since installing Supershine's systems, we've eliminated the inconsistent results that used to cause rework in our garment processing line. The team also helped us configure cycles specific to our fabric types, which made a real difference to output quality.”",
                client: "Aniruddh Bose, Plant Manager, Pharmaceutical Manufacturing Facility",
            },
        ],
    };



    const productData = {
        subtitle: "Recommended Products",
        title: "Precision-Engineered Laundry <br> Machines for Pharma",

    };


    const faqData = {
        title: "FAQs",
        description: "Expert answers for pharmaceutical laundry compliance and validation requirements.",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: "How do Supershine systems ensure pharmaceutical compliance?",
                answer:
                    "Our systems are pre-validated for pharmaceutical use with FDA/GMP-compliant design, documented IQ/OQ/PQ protocols, barrier contamination control, HEPA filtration, automated monitoring, batch traceability, and complete audit documentation, reducing validation burden while ensuring regulatory confidence.",
            },
            {
                question: " What's included in your validation documentation package?",
                answer: "We provide comprehensive Installation Qualification, Operational Qualification, Performance Qualification documentation, validation master plans, test protocols, executed records, temperature mapping studies, cleaning validation, change control procedures, and ongoing compliance support for regulatory inspections.",
            },
            {
                question: "How does barrier washing prevent pharmaceutical cross-contamination?",
                answer:
                    "Barrier washers feature physical separation between contaminated and clean zones with independent loading/unloading sides, HEPA-filtered clean side, sealed pass-through design, and validated protocols ensuring contaminated textiles never contact clean processing environments.",
            },

            {
                question: "Can your systems integrate with our pharmaceutical facility's documentation requirements?",
                answer:
                    "Yes, our equipment features 21 CFR Part 11 compliant data systems, electronic batch records, automated cycle documentation, integration with facility LIMS/QMS platforms, secure audit trails, electronic signatures, and customizable reporting aligned with your SOPs.",
            },

            {
                question: "What cleanroom classifications can your equipment support?",
                answer:
                    "Our systems support ISO Class 5-8 cleanroom environments through low-particulate stainless steel construction, HEPA exhaust filtration, minimal lint generation design, validated cleaning effectiveness, and contamination-controlled operation suitable for GMP-classified manufacturing areas.",
            },

            {
                question: "How long does pharmaceutical system validation typically require?",
                answer:
                    "Complete installation and validation typically requires 3-4 weeks including equipment installation, utility qualification, IQ/OQ/PQ execution, validation report generation, regulatory review, staff training, and operational handover, 40% faster than industry standard through pre-validated platforms.",
            },
        ],
    };

    return (
        <>

            <HealthcareBanner data={Banner} breadcrumb={bannerData.breadcrumb} />
            <HealthcareExcellence data={excellenceData} />
            <HealthcareFacility data={facilityData} />
            <HealthcareCounter data={HeathCareCounter} />
            <HealthcareSmart data={Fashionsmart} />
            <HealthcarePremise data={PremiseData} />
            <HealthcareBrand data={healthcareBrandData} />
            <HealthcareBusinesse data={businessData} />
            <HomeProducts data={productData} extraClass="healthcare-product" initialData={initialData} />
            <HealthcareFaq data={faqData} />
        </>
    )
}









